import {timeWeek, timeMonth, timeDay} from 'd3-time';
import React from 'react';
import {timeFormat} from 'd3-time-format';
import Axis from 'components/pure/charts/custom/Axis';

/**
 * Given scales, margins, and the wrapping svg dimensions, render (relatively specific) axes for the chart.
 * Note that the axes are relatively coupled to this current implementation of the chart - time/bottom x axis,
 * scalar y axis with 5 ticks.  To extend this, pass xProps/yProps down to this component instead.
 *
 * TODO move this into ev-charts (properly, remove the versions currently there, they've diverged)
 *
 * @param scales
 * @param margins
 * @param formatValue - how to format the ticks
 * @returns X and Y axes, tick marks outside the graph
 */
const Axes = ({scales, margins, formatValue = s => s}) => {
  const [first, last] = scales.xScale.domain();

  const secondsBetween = (last - first) / 1000;
  const halfAYearInSeconds = (365 / 2) * 24 * 60 * 60;
  const sixWeeksInSeconds = 7 * 6 * 24 * 60 * 60;
  const twoWeeksInSeconds = 7 * 2 * 24 * 60 * 60;
  const oneWeekInSeconds = 7 * 24 * 60 * 60;

  const largeRange = secondsBetween > halfAYearInSeconds;
  const biweeklyRange = secondsBetween <= halfAYearInSeconds && secondsBetween > sixWeeksInSeconds;
  const weeklyRange = secondsBetween <= sixWeeksInSeconds && secondsBetween > twoWeeksInSeconds;
  const everyOtherDayRange =
    secondsBetween <= twoWeeksInSeconds && secondsBetween > oneWeekInSeconds;

  // otherwise - we're in the single week range, ticks can be every day

  let ticks = null;
  if (largeRange) {
    ticks = timeMonth.every(1);
  } else if (biweeklyRange) {
    ticks = timeWeek.every(2);
  } else if (weeklyRange) {
    ticks = timeWeek.every(1);
  } else if (everyOtherDayRange) {
    ticks = timeDay.every(2);
  } else {
    ticks = timeDay.every(1);
  }

  const xProps = {
    orient: 'Bottom',
    scale: scales.xScale,
    translate: `translate(0, ${scales.yScale.range()[0]})`,
    tickSize: -5,
    ticks: ticks, // ticks depending on how big the range is
    tickFormat: timeFormat('%b %d'), // February 15 -> Feb 15
  };

  const yProps = {
    orient: 'Left',
    scale: scales.yScale,
    translate: `translate(${margins.left}, 0)`,
    tickSize: -5,
    ticks: 5,
    tickFormat: formatValue,
  };

  return (
    <g>
      <Axis {...xProps} />
      <Axis {...yProps} />
    </g>
  );
};

export default Axes;
